import React from "react";
import { Container, Row } from "react-bootstrap";
import WbSlots from "../WbSlots";
import Layout from "../shared/Layout";

const WbSlotsPage = () => {
  return (
    <Layout>
      <Container>
        <Row>
          <WbSlots />
        </Row>
      </Container>
    </Layout>
  );
};

export default WbSlotsPage;
